export default __webpack_public_path__ + "static/media/7.753d0258.gif";